import { CircularProgress, Grid } from '@material-ui/core';

const Loader = () => (
  <Grid container direction="row" justify="center" alignItems="center">
    <CircularProgress />
  </Grid>
);

export default Loader;
